export default {"src":"/login-app/[GIT_HASH]/_next/static/media/check_circle.2cd84a5f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};